exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkboxTool[data-v-aaa1671e]{width:20px;height:20px;vertical-align:middle;margin-bottom:2px}.underline[data-v-aaa1671e]{border-bottom:.1em solid #ddd;vertical-align:-webkit-baseline-middle}.uppercase[data-v-aaa1671e]{text-transform:uppercase}.break-row[data-v-aaa1671e]{margin-bottom:20px}.toolName[data-v-aaa1671e]{color:var(--theme-color-primary)}span[data-v-aaa1671e]{content:\"\\21B3\"}.tier-2[data-v-aaa1671e]{margin-left:5%}.tier-3[data-v-aaa1671e]{margin-left:10%}@media only screen and (min-device-width:320px) and (max-device-width:480px){.mobileFont[data-v-aaa1671e]{font-size:13px}}.tier-2[data-v-aaa1671e]:before,.tier-3[data-v-aaa1671e]:before{content:\"\\21B3\";padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aaa1671e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/virtual-assistant/tools.vue
// module id = z3kh
// module chunks = 0